import { createSelector } from '@reduxjs/toolkit';
import { getChannelListState } from './getChannelListState';

export const getSelectedChannelOrder = createSelector(
  getChannelListState,
  (channelList) => channelList.selectedChannelOrder,
);
